import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Captions are STICKY: each stays until the next line begins, so fromSec values
// are ~5-6s apart for a readable pace. Every claim is grounded in EAKC-MVP:
//   - mission_blackboard_entries + 6 sections + is_current trigger: supabase/migrations/113
//   - blackboard_read / blackboard_write tools: src/lib/blackboard/tools.ts
//   - blocked_by DAG + nextStep: src/lib/missions/orchestrator/state-machine.ts
//   - dispatch loop + prior-step preamble: src/lib/missions/orchestrator/process/process-mission.ts
//     + dispatch/dispatch-step-agents.ts + caches/prior-outputs.ts
//   - expected_outputs post-verify: src/lib/missions/orchestrator/verification/verify-expected-outputs.ts

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 4.5, caption: "My mission agents finish each other's work — and they never talk to each other." },
];

export const PROBLEM: ScriptLine[] = [
  { scene: "problem", fromSec: 0.4, holdSec: 5.5, caption: "The naive design is a group chat: agents message each other to hand off results." },
  { scene: "problem", fromSec: 6.0, holdSec: 5.5, caption: "That gets lossy and unauditable fast — who said what, which version is real? I don't do that." },
];

export const BOARD: ScriptLine[] = [
  { scene: "board", fromSec: 0.4, holdSec: 5.5, caption: "Instead, every mission has ONE shared blackboard — a Postgres table, migration 113." },
  { scene: "board", fromSec: 6.0, holdSec: 5.5, caption: "Six typed sections. Each entry has a key, and exactly one row is marked is_current." },
];

export const DEPS: ScriptLine[] = [
  { scene: "deps", fromSec: 0.4, holdSec: 5.5, caption: "Steps declare blocked_by — a dependency graph, not a chat thread." },
  { scene: "deps", fromSec: 6.0, holdSec: 5.5, caption: "A step won't dispatch until every step it depends on is marked complete." },
];

export const LOOP: ScriptLine[] = [
  { scene: "loop", fromSec: 0.4, holdSec: 6.0, caption: "The orchestrator runs a loop: read the board, find the next ready step, dispatch it." },
  { scene: "loop", fromSec: 6.5, holdSec: 6.0, caption: "When a step finishes, its output becomes context the next step reads. Then repeat." },
];

export const CODE: ScriptLine[] = [
  { scene: "code", fromSec: 0.5, holdSec: 6.0, caption: "The producer agent calls blackboard_write — section, key, value. Append-only; a trigger versions it." },
  { scene: "code", fromSec: 6.8, holdSec: 6.5, caption: "The consumer step gets the prior output prepended to its prompt. No agent ever messaged another." },
];

export const GATE: ScriptLine[] = [
  { scene: "gate", fromSec: 0.4, holdSec: 5.5, caption: "Catch: an LLM can claim success and skip the write. So I don't trust the claim." },
  { scene: "gate", fromSec: 6.0, holdSec: 5.5, caption: "expected_outputs re-checks the board after the step. No entry, no pass — the step retries." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 5.5, caption: "Coordination isn't conversation. It's a shared, versioned memory plus a dependency graph." },
  { scene: "outro", fromSec: 6.0, holdSec: 4.5, caption: "Next: why fixed-size chunks are killing your RAG — and adaptive chunking." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
